<template>
  <v-layout row wrap class="pt-4">
    <v-flex xs12>
      <v-toolbar flat color="white">
        <v-toolbar-title>Результат</v-toolbar-title>
        <v-layout row>
          <v-flex xs4>
            <v-btn color="success" @click="$store.commit('changeIsReportFormed', false)">Новый отчет</v-btn>
            <v-btn color="success" :to="'/reports/print'">Печать</v-btn>
          </v-flex>
          <v-flex xs4 offset-xs4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Поиск"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-data-table
        disable-initial-sort
        :headers="headers"
        :items="reportResults"
        :search="search"
        rows-per-page-text="Отображать"
        class="elevation-10"
        sort-icon="fa-angle-up"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.employee_name }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('YYYY-MM-DD') }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('HH:mm:ss') }}</td>
          <td class="text-xs-left">{{ props.item.action_datetime | date('YYYY-MM-DD HH:mm:ss') }}</td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="error" icon="warning">
            Данных не обнаружено.
          </v-alert>
        </template>
        <template slot="pageText" slot-scope="props">
          Страница {{ props.pageStart }} из {{ props.pageStop }} всего {{ props.itemsLength }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          По запросу "{{ search }}" ничего не найдено.
        </v-alert>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        search: '',
        headers: [
          {text: 'Ф.И.О сотрудника', align: 'left', value: 'employee_name'},
          {text: 'День', align: 'left', value: 'action_datetime'},
          {text: 'Время', align: 'left', value: 'action_datetime'},
          {text: 'Полная дата', align: 'left', value: 'action_datetime'}
        ]
      }
    },
    destroyed() {
      this.$store.commit('clearReportData')
      this.$store.commit('changeIsReportFormed', false)
    },
    computed: {
      reportResults() {
        return this.$store.getters.reportData
      }
    }
  }
</script>
